"use client"

import { motion } from "framer-motion"
import { ArrowRight } from "lucide-react"
import { AppLink } from "@/components/navigation/app-link"
import { DataIntegrationsHub } from "@/components/pages/landing/data-integrations-hub"

export function PlatformSection() {
  return (
    <section id="platform" className="scroll-mt-24 bg-white py-20">
      <div className="container mx-auto max-w-6xl px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
              The SigmAI platform
            </span>
            <h2 className="mt-3 text-3xl font-bold leading-tight tracking-tight text-slate-900 md:text-4xl">
              One platform for the{" "}
              <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                whole career
              </span>{" "}
              of a player
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-600">
              The SigmAI app brings performance, recovery, well-being, finances,
              reputation and social reach together, turning scattered data into
              clear, everyday decisions for players and agents.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              That technology is what sets SigmAI apart from a traditional
              football agency: guidance you can trust, backed by a platform you
              can actually use.
            </p>

            <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row">
              <AppLink
                href="/contact"
                className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-3 text-sm font-semibold text-white shadow-lg transition-all duration-300 hover:scale-[1.03] hover:shadow-blue-500/25"
              >
                Schedule a demo
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </AppLink>
              <AppLink
                href="/platform"
                className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition-colors hover:border-slate-300 hover:bg-slate-50"
              >
                Explore the platform
                <ArrowRight className="h-4 w-4" />
              </AppLink>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <DataIntegrationsHub compact />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
